export { CaseCaseFollowUpScenario } from './generated/CaseCaseFollowUpScenario.js';